import React, { useState, useEffect } from "react";
import Header from "../components/header";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import ScrollToTopButton from "../components/ScrollToTopButton";
import FloatingContactBubble from "../components/FloatingContactBubble";
import ScrollToTop from "../components/ScrollToTop";

const HomeLayout = ({ setHeaderHeight, headerHeight, user, refreshUser }) => {
  // --- LOGIC CÀI ĐẶT APP (PWA) ---
  const [installPrompt, setInstallPrompt] = useState(null);

  useEffect(() => {
    // 1. Đăng ký Service Worker để trình duyệt công nhận là App
    if ("serviceWorker" in navigator) {
      // Thêm dấu / ở trước để đảm bảo nó tìm đúng file trong thư mục public
      navigator.serviceWorker
        .register("/service-worker.js")
        .then(() => console.log("SW đã chạy!"))
        .catch((err) => console.log("SW bị lỗi đường dẫn:", err));
    }

    // 2. Lắng nghe sự kiện sẵn sàng cài đặt
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
      console.log("PWA: Sẵn sàng cài đặt!");
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    return () =>
      window.removeEventListener("beforeinstallprompt", handleBeforeInstall);
  }, []);

  const handleInstallClick = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === "accepted") {
      setInstallPrompt(null);
    }
  };
  console.log("ii", installPrompt, user);

  return (
    <div className="home-layout">
      <ScrollToTop />
      <ScrollToTopButton />

      {}
      <Header
        setHeaderHeight={setHeaderHeight}
        currentUserd={user}
        onLogout={refreshUser}
      />

      {}
     

      <main className="content-area">
        <Outlet />
      </main>

      <Footer />
      <FloatingContactBubble />
    </div>
  );
};

// --- CSS styles ---
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.85)",
  zIndex: 99999,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px",
};

const modalStyle = {
  background: "white",
  padding: "30px",
  borderRadius: "20px",
  textAlign: "center",
  maxWidth: "350px",
  width: "100%",
  boxShadow: "0 15px 35px rgba(0,0,0,0.5)",
};

const btnInstallStyle = {
  width: "100%",
  padding: "14px",
  marginTop: "20px",
  background: "#ff4d4f",
  color: "white",
  border: "none",
  borderRadius: "10px",
  fontWeight: "bold",
  fontSize: "16px",
  cursor: "pointer",
};

const btnSkipStyle = {
  marginTop: "15px",
  background: "none",
  border: "none",
  color: "#999",
  cursor: "pointer",
};

export default HomeLayout;
